import { render, staticRenderFns } from "./EventTeamsForm.vue?vue&type=template&id=295b104b&scoped=true"
import script from "./EventTeamsForm.vue?vue&type=script&lang=js"
export * from "./EventTeamsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295b104b",
  null
  
)

export default component.exports